
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"width":"16px","height":"16px"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","style":"width:16px;height:16px"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.584 10.376L4.518 5.777A.5.5 0 0 1 4.934 5h6.132a.5.5 0 0 1 .416.777l-3.066 4.599a.5.5 0 0 1-.832 0z"}})])
          )
        }
      }
    